import { Spin } from 'antd';
import styled from 'react-emotion/macro';
import { color, width, height } from 'styled-system';

export const Overlay = styled(Spin)` &&& {
  position: absolute;
  display: flex;
  width: inherit;
  height: inherit;
  justify-content: center;
  align-items: center;
  z-index: 99;
  background: inherit;
  pointer-events: none;
  transition: opacity .5s;
  ${width}
  ${height}
  
  .anticon {
    opacity: .6;
    width: 200px;
    ${color}

    ::after {
      display: block;
      content: ${props => props.notext || `'${props.useupdatingtext ? 'Updating data' : 'Retrieving data'}'`};
      font-size: 13px;
      text-align: center;
      margin-top: 18px;
    }
  }

  &.ant-spin-spinning {
    opacity: 1;
    transition: opacity 0s !important;
  }
}`;
